import { render, staticRenderFns } from "./DataCounter.vue?vue&type=template&id=2b401fb8&scoped=true&"
import script from "./DataCounter.vue?vue&type=script&lang=js&"
export * from "./DataCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b401fb8",
  null
  
)

export default component.exports